import React, { useState, useEffect, useDebugValue, useRef, useContext } from "react";
import notificationSound from "../../Sound/messageTone.mp3";
import Swal from "sweetalert2";
import trash from "../../images/trash.svg";
import { Modal } from "react-bootstrap";
import cut from "../../images/close-circle.svg";
import NoIndex from "..//NoIndex";
import ContectBook from "./Contact_Add";
import axios from "axios";
import food from "../../images/Pexels Photo by Malidate Van.svg";
import Cart from "../../images/Cart.svg";
import attach from "../../images/Attach File.svg";
import { Form, FormGroup, FormControl } from "react-bootstrap";
import { Card, Row, Col } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Chat_BG from "../../images/chat_BG.png";
import wpImage from "../../images/Whatsapp.svg";
import Edit from "../../images/Edit.svg";
import Tag from "../../images/Tag-2.svg";
import sendImage from "../../images/Send.svg";
import MyContext from "../../MyContext";
import { Dropdown, Button } from "react-bootstrap";
import Placeholder from "../../images/Place Holder 3 1.webp"
import Placeholder1 from "../../images/Place Holder.webp"
import Placeholder2 from "../../images/Place Holder_1.webp"
import attachimage from "../../images/Photo.svg";
import attachdoc from "../../images/Doc.svg";
import attachvideo from "../../images/Video.svg";
import assignedImg from "../../images/User Assigned.svg"
import { MdMenuBook } from "react-icons/md";
import { FaImage, FaVideo, FaFileAlt, FaLink, FaBookOpen, FaPizzaSlice, FaClipboardList } from "react-icons/fa";
import { LayoutTemplate, Folder, Paperclip } from "lucide-react";
import NewNumberTemplateModal from "./SendTemplateModal";




const Chats = ({ userID }) => {
  const audioRef = useRef(null);
  const [audio, setAudio] = useState(null);
  const { baseUrl, config } = useContext(MyContext);
  let BASIC_AUTH = "YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=";
  const [People, setPeople] = useState([]);
  const [SelectedPeople, setSelectedPeople] = useState("");
  const messagesEndRef = useRef(null);
  const navigate = useNavigate();
  const [selectedContactId, setSelectedContactId] = useState("");
  const [messageText, setMessageText] = useState("");
  const [messages, setMessages] = useState([]);
  const [chatShow, setChatShow] = useState(true);
  const [allContectShow, setAllContectShow] = useState(false);
  const [activeButton, setActiveButton] = useState("1");
  const [mobileNumberSelected, setMobileNumberSelected] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [chats, setChats] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const CONTACTS_PAGE_SIZE = 50;
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingContacts, setIsLoadingContacts] = useState(false);
  const [Labels, setLabels] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [LoopIt, setLoopIt] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileUpload, setSelectedFileUpload] = useState(null);

  const [previewUrl, setPreviewUrl] = useState(null);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [mediaUploadLoading, setMediaUploadLoading] = useState(false);

  const [mediaType, setMediaType] = useState("");
  const [showMediaModal, setShowMediaModal] = useState(false);

  // Create references for file inputs
  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const documentInputRef = useRef(null);

  // Create references for file inputs for Upload
  const imageInputRefupload = useRef(null);
  const videoInputRefupload = useRef(null);
  const documentInputRefupload = useRef(null);


  const [chatPageIndex, setChatPageIndex] = useState(1);
  const [chatHasMore, setChatHasMore] = useState(true);
  const [isLoadingChats, setIsLoadingChats] = useState(false);

  const chatContainerRef = useRef(null);

  const hasScrolledInitially = useRef(false);
  const previousScrollHeight = useRef(0);
  const isInitialLoad = useRef(false);
  const inflightRef = useRef(false);
  const contactsScrollRef = useRef(null);   // scroll container for the contacts list
  const contactsSentinelRef = useRef(null); // sentinel at the bottom of the list

const [showNewTplModal, setShowNewTplModal] = useState(false);
  // Open modal and fetch media
  const openModal = () => {
    fetchUploadedMedia();
    setShowMediaModal(true);
  };

  const handleCloseModal = () => {
    setSelectedMedia(null);
    setSelectedMediaId(null);
    setShowMediaModal(false);
    removeFile();
  };
  // Handle file selection
  const handleFileSelect = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (mediaType === "img" && file.type.startsWith("image/")) {
        // Handle Image Selection
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          setSelectedFile(reader.result.split(",")[1]); // Extract Base64 part
          setPreviewUrl(reader.result);
        };
        reader.onerror = (error) => {
          console.error("Error reading image file:", error);
        };
      }


      else if (mediaType === "video" && file.type === "video/mp4") {
        // Validate Video Size (Max 5MB)
        if (file.size > 16 * 1024 * 1024) {
          alert("Video file size must be 5MB or less.");
          removeFile();
          return;
        }

        // Handle Video Selection
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          setSelectedFile(reader.result.split(",")[1]); // Extract Base64 part
          setPreviewUrl(reader.result);
        };
        reader.onerror = (error) => {
          console.error("Error reading video file:", error);
        };
      }
      else if (mediaType === "pdf" && (file.type === "application/pdf" || file.type.startsWith("application/msword") || file.type.startsWith("application/vnd.openxmlformats-officedocument"))) {
        // Handle Document Selection (PDF, DOCX, etc.)
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          setSelectedFile(reader.result.split(",")[1]); // Extract Base64 part
          setPreviewUrl(reader.result);
        };
        reader.onerror = (error) => {
          console.error("Error reading document file:", error);
        };
      }
      else {
        alert(`Please select a valid ${mediaType} file.`);
      }
    }
  };

  // Handle file selection for Upload
  const handleFileSelectUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (mediaType === "img" && file.type.startsWith("image/")) {
        // Handle Image Selection
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64Data = reader.result.split(",")[1]; // Extract Base64 part
          setSelectedFileUpload(base64Data);
          uploadVideoAPI(base64Data); // 🔥 Auto-call API after file is loaded
        };
        reader.onerror = (error) => console.error("Error reading image file:", error);
      }
      else if (mediaType === "video" && file.type === "video/mp4") {
        // Validate Video Size (Max 5MB)
        if (file.size > 16 * 1024 * 1024) {
          alert("Video file size must be 5MB or less.");
          removeFile();
          return;
        }
        // Handle Video Selection
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64Data = reader.result.split(",")[1]; // Extract Base64 part
          setSelectedFileUpload(base64Data);
          uploadVideoAPI(base64Data); // 🔥 Auto-call API after file is loaded
        };
        reader.onerror = (error) => console.error("Error reading video file:", error);
      }
      else if (mediaType === "pdf" && (file.type === "application/pdf" || file.type.startsWith("application/msword") || file.type.startsWith("application/vnd.openxmlformats-officedocument"))) {
        // Handle Document Selection (PDF, DOCX, etc.)
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64Data = reader.result.split(",")[1]; // Extract Base64 part
          setSelectedFileUpload(base64Data);
          uploadVideoAPI(base64Data); // 🔥 Auto-call API after file is loaded
        };
        reader.onerror = (error) => console.error("Error reading document file:", error);
      }
      else {
        alert(`Please select a valid ${mediaType} file.`);
      }
    }
  };

  const removeFile = () => {
    setSelectedFile(null);
    setPreviewUrl(null);
    setMediaType(null); // Reset media type as well

    // Reset the correct input field based on media type
    if (mediaType === "video" && videoInputRef.current) {
      videoInputRef.current.value = "";
    } else if (mediaType === "img" && imageInputRef.current) {
      imageInputRef.current.value = "";
    } else if (mediaType === "pdf" && documentInputRef.current) {
      documentInputRef.current.value = "";
    }
  };

  const uploadVideoAPI = async (fileData) => {
    if (!fileData) return;
    setMediaUploadLoading(true);
    const payload = {
      userid: userID, // Replace with actual user ID
      mediaData: fileData, // Base64 of the file
      mediaType: mediaType,
    };

    try {
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/uploadMedia`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=", // Add Authorization header
          },
        }
      );
      setPreviewUrl(null);
      if (response.status === 200) {
        toast.success("File uploaded successfully");
        console.log("File uploaded successfully");
        fetchUploadedMedia();
        removeFile();
      } else {
        console.error("Failed to upload file", response);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setMediaUploadLoading(false);
    }
  };

  const sendVideo = async () => {
    if (!selectedFile) return;
    setMediaLoading(true);
    const payload = {
      userid: userID, // Replace with actual user ID
      mobile: mobileNumberSelected, // Replace with recipient's mobile
      mediaData: selectedFile, // Base64 of the video
      mediaType: mediaType,
      message: message || "", // Optional caption
    };

    try {
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/sendMedia`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=", // Add Authorization header
          },
        }
      );
      setPreviewUrl(null);
      if (response.status === 200) {
        console.log("Video sent successfully");
        removeFile();
      } else {
        console.error("Failed to send video", response);
      }
    } catch (error) {
      console.error("Error sending video:", error);
    } finally {
      setMediaLoading(false); // Stop loading
    }
  };


  const [mediaList, setMediaList] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;


  // const [loading, setLoading] = useState(false);
  const fetchUploadedMedia = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${baseUrl}/api/Whatsapp/getUploadedMedia`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
        },
        body: JSON.stringify({
          userid: userID,
          offset: "100", // Keeping API payload as it is
          page: "1",
        }),
      });
      const data = await response.json();
      if (data.responseCode === "00") {
        setMediaList(data.data); // Store the entire data for frontend pagination
      }
    } catch (error) {
      console.error("Error fetching media:", error);
    } finally {
      setLoading(false);
    }
  };



  // Get the current items for the selected page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentMedia = mediaList.slice(indexOfFirstItem, indexOfLastItem);

  const [selectedMediaId, setSelectedMediaId] = useState(null); // Store media ID
  const [sending, setSending] = useState(false);

  const sendMediaToUser = async () => {
    if (!selectedMediaId) return; // Ensure a media is selected
    setSending(true);

    const payload = {
      userid: userID, // Replace with actual user ID
      mobile: mobileNumberSelected, // Replace with actual user mobile
      mediaId: selectedMediaId, // Use selected media ID
      message: "",
    };

    try {
      const response = await fetch(`${baseUrl}/api/Whatsapp/sendMediaFromLibrary`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=", // Add Authorization header
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.responseCode === "00") {

        toast.success(result.responseMessage);
        handleCloseModal();
      } else {
        toast.error(result.responseMessage);
        handleCloseModal();
      }
    } catch (error) {
      console.error("Error sending media:", error);
      toast.error("⚠️ An error occurred while sending the media.");
    } finally {
      setSending(false);
    }
  };
  const handleSelectChange = (event) => {
    setSelectedLabel(event.target.value);
  };
  useEffect(() => {
    // Scroll to the bottom when chats update
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chats]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    // Trim the message to remove unnecessary whitespace
    const trimmedMessage = message.trim();
    if (selectedFile) {
      sendVideo();
      return;
    }
    // Validate the message
    if (!trimmedMessage) {
      console.error("Message cannot be empty or contain only spaces.");
      return;
    }

    // Validate other required fields
    if (!userID) {
      console.error("User ID is missing.");
      return;
    }

    if (!mobileNumberSelected) {
      console.error("Mobile number is missing.");
      alert("Please select a valid contact number.");
      return;
    }

    // setLoading(true);

    // Prepare headers
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU="
    );

    // Prepare the request body
    const raw = JSON.stringify({
      userid: userID,
      secret: "NA",
      message: trimmedMessage,
      contact: mobileNumberSelected,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      // Send the API request
      const response = await fetch(
        `${baseUrl}/api/Whatsapp/sendInstantMessage`,
        requestOptions
      );
      const result = await response.text();
      console.log("API Response:", result);

      // Reset message and fetch updated chat
      setMessage("");
      fetchChats();
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Failed to send the message. Please try again."); // Optionally show an error alert
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userID || !mobileNumberSelected) return;

    const socket = new WebSocket(
      `wss://api.anlook.com/ws?userId=${userID}&roomId=${mobileNumberSelected}`
    );

    socket.onopen = () => {
      console.log("WebSocket Connected to Chat:", mobileNumberSelected);
    };
    socket.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);
        fetchChats(); fetchWebSocketContact();
        if (audioRef.current) {
          audioRef.current.play().catch(() => { });
        }
      } catch (error) {
        console.error("Invalid JSON message:", event.data);
      }
    };

    socket.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };

    socket.onclose = (event) => {
      console.log("WebSocket Disconnected:", event.reason);
    };

    return () => {
      socket.close();
    };
  }, [userID, mobileNumberSelected]);


  // Initialize audio once
  useEffect(() => {
    const audio = new Audio(notificationSound);
    audio.preload = "auto";
    audio.loop = false;
    audio.volume = 1.0;
    audioRef.current = audio;

    // Unlock audio on first user interaction
    const unlockAudio = () => {
      audio.muted = true;
      audio
        .play()
        .then(() => {
          audio.pause();
          audio.muted = false;
          localStorage.setItem("soundUnlocked", "true");
          console.log("🔓 Audio unlocked");
        })
        .catch((err) => {
          console.warn("Unlock failed:", err);
        });

      document.removeEventListener("click", unlockAudio);
      document.removeEventListener("mousemove", unlockAudio);
    };

    if (localStorage.getItem("soundUnlocked") !== "true") {
      document.addEventListener("click", unlockAudio, { once: true });
      document.addEventListener("mousemove", unlockAudio, { once: true });
    }

    return () => {
      document.removeEventListener("click", unlockAudio);
      document.removeEventListener("mousemove", unlockAudio);
    };
  }, []);


  useEffect(() => {
    if (!userID) return;

    const socket = new WebSocket(
      `wss://api.anlook.com/ws?userId=${userID}&roomId=new_conversation`
    );

    socket.onopen = () => {
      console.log("🟢 WebSocket Connected");
    };

    socket.onmessage = (event) => {
      try {
        const message = JSON.parse(event.data);
        console.log("WebSocket Message Received:", message);


        if (audioRef.current) {
          audioRef.current
            .play()
            .then(() => console.log("Notification played"))
            .catch((err) => console.warn("Sound play failed:", err));
        }
        fetchWebSocketContact();
        // fetchData();


        // Gentle top-right toast
        Swal.fire({
          toast: true,
          position: "top-end", // top-right corner
          icon: "info",
          title: message?.text || "You have a new message.",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          background: "#fff",
          color: "#333",
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          }
        });
      } catch (error) {
        console.error("Invalid JSON message:", event.data);
      }
    };

    socket.onerror = (error) => {
      console.error("❌ WebSocket Error:", error);
    };

    socket.onclose = (event) => {
      console.log("🔴 WebSocket Closed:", event.reason);
    };

    return () => {
      socket.close();
    };
  }, [userID]);

  // Optional: manual test button
  const playSoundManually = () => {
    if (audioRef.current) {
      audioRef.current
        .play()
        .then(() => console.log("🔊 Manual test sound played"))
        .catch((err) => console.warn("Manual play failed:", err));
    }
  };


  const fetchChats = async () => {
    if (!chatHasMore) return;

    setIsLoadingChats(true);

    try {
      const response = await fetch(`${baseUrl}/api/Whatsapp/v1.0/getWhatsappConversation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
        },
        body: JSON.stringify({
          userid: userID,
          secret: "",
          contact: mobileNumberSelected,
          pageIndex: chatPageIndex.toString(),
          recordPerPage: "20",
        }),
      });

      const result = await response.json();
      const newMessages = result.data || [];

      const container = chatContainerRef.current;

      if (newMessages.length === 0) {
        setChatHasMore(false);
      } else {
        if (container) {
          previousScrollHeight.current = container.scrollHeight;
        }

        const reversed = [...newMessages].reverse(); // ensure newest at bottom
        setChats((prev) => [...reversed, ...prev]);
        setChatPageIndex((prev) => prev + 1);
      }

      setTimeout(() => {
        const container = chatContainerRef.current;

        // Scroll ONLY on first load
        if (isInitialLoad.current && container && !hasScrolledInitially.current) {
          container.scrollTop = container.scrollHeight;
          hasScrolledInitially.current = true;
          isInitialLoad.current = false;
        }
        // On loading older messages, restore position
        else if (container && previousScrollHeight.current) {
          const newScrollHeight = container.scrollHeight;
          const scrollOffset = newScrollHeight - previousScrollHeight.current;
          container.scrollTop = scrollOffset;
        }
      }, 0);
    } catch (err) {
      console.error("Error fetching conversation:", err);
    } finally {
      setIsLoadingChats(false);
    }
  };




  // Handler to select a contact
  const handleSelectContact = (contact) => {
    if (selectedContactId === contact.id) return;

    setChats([]);
    setChatPageIndex(1);
    setChatHasMore(true);
    setIsLoadingChats(true);
    setSelectedContactId(contact.id);
    setMobileNumberSelected(contact.contact_number);

    // reset scroll control flags
    hasScrolledInitially.current = false;
    isInitialLoad.current = true;

    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  };
  useEffect(() => {
    if (mobileNumberSelected && chatPageIndex === 1) {
      fetchChats(); // only fires AFTER mobileNumberSelected is updated
    }
  }, [mobileNumberSelected]);


  const handleSendMessage = () => {
    if (!messageText.trim()) return;
    const newMessage = {
      fromMe: true,
      text: messageText,
      timestamp: new Date().toLocaleTimeString(),
    };
    const updatedMessages = {
      ...messages,
      [selectedContactId]: [...(messages[selectedContactId] || []), newMessage],
    };
    setMessages(updatedMessages);
    setMessageText("");
  };

  const fetchData = async () => {
    if (isLoadingContacts || !hasMore || inflightRef.current) return;
    inflightRef.current = true;
    setIsLoadingContacts(true);

    try {
      const response = await fetch(`${baseUrl}/api/Campaign/v1.0/getContacts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
        },
        body: JSON.stringify({
          userid: userID,
          pageIndex: pageIndex.toString(),
          recordPerPage: String(CONTACTS_PAGE_SIZE), // You can tweak this number based on UI
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch contacts");
      }

      const result = await response.json();
      const rows = Array.isArray(result?.data) ? result.data : [];

      if (rows.length) {
        // Append with de-duplication by stable id
        setContacts((prev) => {
          const merged = [...prev, ...rows];
          const seen = new Set();
          return merged.filter((c) => {
            const id = c?.id ?? c?.contactId ?? c?.mobile; // pick your stable key
            if (!id) return true;
            if (seen.has(id)) return false;
            seen.add(id);
            return true;
          });
        });
        // ✅ advance page; stop when last page is shorter than page size
        if (rows.length < CONTACTS_PAGE_SIZE) {
          setHasMore(false);
        } else {
          setPageIndex((p) => p + 1);
        }
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error.message);
    } finally {
      inflightRef.current = false;
      setIsLoadingContacts(false);
    }
  };
  ;
  const [showModal, setShowModal] = useState(false);
  const [contactInfo, setContactInfo] = useState({
    contactName: "",
    contactNumber: "",
    contactEmail: "",
    gender: "",
    id: "",
    tags: [],
  });
  const [contactInfo1, setContactInfo1] = useState({
    contactName: "",
    contactNumber: "",
    contactEmail: "",
    gender: "",
    id: "",
    tags: [],
  });
  const [contactInfo2, setContactInfo2] = useState({
    contactName: "",
    contactNumber: "",
    contactEmail: "",
    gender: "",
    id: "",
    tags: [],
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "tags") {
      setContactInfo((prevInfo) => ({
        ...prevInfo,
        tags: value.split(",").map((tag) => tag.trim()),
      }));
    } else {
      setContactInfo((prevInfo) => ({
        ...prevInfo,
        [name]: value,
      }));
    }
  };

  const handleEditContactSubmit = async (e) => {
    e.preventDefault();
    try {
      const requestBody = {
        userid: userID,
        contactNumber: contactInfo.contactNumber,
        contactEmail: contactInfo.contactEmail,
        contactName: contactInfo.contactName,
        gender: contactInfo.gender,
        tags: contactInfo.tags,
      };
      const response = await axios.post(
        `${baseUrl}/api/Campaign/editContact`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setContactInfo({
          contactName: "",
          contactNumber: "",
          contactEmail: "",
          gender: "",
          tags: [""],
        });
        setShowModal(false);
        fetchData();
      } else {
        toast.error("Failed to edit contact");
      }
    } catch (error) {
      console.error(error);
      // Handle error here
    }
  };

  // Chat Assign Chat and Labelling System ########################################################################################################################################################
  const fetchWebSocketContact = async () => {
    // if (isLoadingContacts) return;
    // setContacts([]);
    // inflightRef.current = true;
    // setIsLoadingContacts(true);

    try {
      const response = await fetch(`${baseUrl}/api/Campaign/v1.0/getContacts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
        },
        body: JSON.stringify({
          userid: userID,
          pageIndex: 1,
          recordPerPage: 50, // You can tweak this number based on UI
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch contacts");
      }

      const result = await response.json();
      const rows = Array.isArray(result?.data) ? result.data : [];

      if (rows.length) {
        // Append with de-duplication by stable id
        setContacts(result.data);
        // ✅ advance page; stop when last page is shorter than page size
        if (rows.length < CONTACTS_PAGE_SIZE) {
          setHasMore(false);
        } else {
          setPageIndex((p) => p + 1);
        }
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error.message);
    } finally {
      inflightRef.current = false;
      setIsLoadingContacts(false);
    }
  };
  const fetchTabSwitchContact = async () => {
    // if (isLoadingContacts) return;
    // setContacts([]);
    // inflightRef.current = true;
    setIsLoadingContacts(true);

    try {
      const response = await fetch(`${baseUrl}/api/Campaign/v1.0/getContacts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=",
        },
        body: JSON.stringify({
          userid: userID,
          pageIndex: 1,
          recordPerPage: 50, // You can tweak this number based on UI
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch contacts");
      }

      const result = await response.json();
      const rows = Array.isArray(result?.data) ? result.data : [];

      if (rows.length) {
        // Append with de-duplication by stable id
        setContacts(result.data);
        // ✅ advance page; stop when last page is shorter than page size
        if (rows.length < CONTACTS_PAGE_SIZE) {
          setHasMore(false);
        } else {
          setPageIndex((p) => p + 1);
        }
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error.message);
    } finally {
      inflightRef.current = false;
      setIsLoadingContacts(false);
    }
  };
  const fetchLabel = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU="
      );

      const raw = JSON.stringify({
        userid: userID,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        `${baseUrl}/api/Whatsapp/v1/getChatLabels`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const result = await response.json(); // Parse the response as JSON

      // Update state with fetched contacts
      if (result.data !== null) {
        setLabels(result.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    fetchData();
    fetchLabel();
  }, [])


  const getAllUserList = async (e) => {
    try {
      setLoading(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);
      var raw = JSON.stringify({
        userid: userID,
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${baseUrl}/api/User/getAllUserList`,
        requestOptions
      );
      const data = await res.json();
      if (data?.responseCode == "00") {
        setPeople(data?.response);
      } else {
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false); // Set loading to false after API call
    }
  };
  useEffect(() => {
    getAllUserList();
  }, []);


  const AddTagContactSubmit = async (e) => {
    // e.preventDefault();
    console.log(selectedLabel);
    // Use find instead of map to get the matching label
    const Label = Labels.find((item) => selectedLabel === item.title);
    // if (!Label) {
    //   toast.error("Label not found. Please select a valid label.");
    //   return; // Exit if no matching label is found
    // }
    try {
      const requestBody = {
        contactId: contactInfo1.id,
        contactNumber: contactInfo1.contactNumber,
        userid: userID,
        label: Label, // Ensure the label is correctly assigned
      };
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/v1/assignLabelToChat`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setSelectedLabel("Add Label");
        setContactInfo({
          contactName: "",
          contactNumber: "",
          contactEmail: "",
          gender: "",
          tags: [""],
        });
        fetchData();
      } else {
        // toast.error("Failed to edit contact");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while updating the contact.");
    }
  };
  const AssignChat = async (e) => {
    // e.preventDefault();
    console.log(selectedLabel);

    // Use find instead of map to get the matching label
    const Label = Labels.find((item) => selectedLabel === item.title);
    try {
      const requestBody = {
        contactId: contactInfo2.id,
        teamMemberId: SelectedPeople,
        userid: userID,
      };
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/v1/assignTeamMemberToChat`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        // toast.success(response.data.responseMessage);
        setSelectedLabel("");
        setContactInfo({
          contactName: "",
          contactNumber: "",
          contactEmail: "",
          gender: "",
          tags: [""],
        });
        fetchData();
      } else {
        // toast.error("Failed to edit contact");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while updating the contact.");
    }
  };
  useEffect(() => {
    if (SelectedPeople) {
      AssignChat();
    }

  }, [SelectedPeople]);

  useEffect(() => {
    if (selectedLabel) { AddTagContactSubmit(); }

  }, [selectedLabel]);
  const deleteContactAPI = async (number) => {
    try {
      const requestBody = {
        userid: userID,
        contactNumber: number,
      };
      // Show confirmation dialog
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      if (result.isConfirmed) {
        // User confirmed, proceed with deletion
        const response = await axios.post(
          `${baseUrl}/api/Campaign/deleteContact`,
          requestBody,
          config
        );
        if (response.data.responseCode === "00") {
          // Contact deleted successfully
          toast.success(response.data.responseMessage);
          fetchData();
        } else {
          // Failed to delete contact
          toast.error(response.data.responseMessage);
        }
      }
    } catch (error) {
      console.error(error);
      // Handle error here
      Swal.fire("Error!", "An error occurred while deleting contact.", "error");
    }
  };
  const setSelectedContact = (selectedContactId) => {
    console.log("hii");
    console.log(selectedContactId);
    setShowModal(true);
    const selectedContact = contacts.find(
      (contact) => contact.id === selectedContactId
    );
    console.log(selectedContact);
    if (selectedContact) {
      setContactInfo({
        contactName: selectedContact.contact_name,
        contactNumber: selectedContact.contact_number,
        contactEmail: selectedContact.contact_email,
        gender: selectedContact.gender,
        tags: selectedContact.tags,
      });
      console.log(contactInfo);
    }
  };
  const setSelectedContact1 = (selectedContactId) => {
    const selectedContact = contacts.find(
      (contact) => contact.id === selectedContactId
    );
    console.log(selectedContact);
    if (selectedContact) {
      setContactInfo1({
        contactName: selectedContact.contact_name,
        contactNumber: selectedContact.contact_number,
        contactEmail: selectedContact.contact_email,
        gender: selectedContact.gender,
        id: selectedContact.id,
        tags: selectedContact.tags,
      });
      console.log(contactInfo);
    }
  };
  const setSelectedContact2 = (selectedContactId) => {
    const selectedContact = contacts.find(
      (contact) => contact.id === selectedContactId
    );
    console.log(selectedContact);
    if (selectedContact) {
      setContactInfo2({
        contactName: selectedContact.contact_name,
        contactNumber: selectedContact.contact_number,
        contactEmail: selectedContact.contact_email,
        gender: selectedContact.gender,
        id: selectedContact.id,
        tags: selectedContact.tags,
      });
      console.log(contactInfo);
    }
  };

  // Unique Messages sending or displaying option ################################################################################################################################################
  function formatWhatsAppMessage(template) {
    if (!template || !template.components) return null;

    return (
      <div className="whatsapp-template">
        {template.components.map((component, index) => {
          switch (component.type) {
            case "HEADER":
              return renderHeader(component, index);
            case "BODY":
              return renderBody(component, index);
            case "FOOTER":
              return <footer className="text-muted" key={index}>{component.text}</footer>;
            case "BUTTONS":
              return renderButtons(component.buttons, index);
            default:
              return null;
          }
        })}
      </div>
    );
  }

  // **Render Header Component**
  function renderHeader(headerComponent, key) {
    if (!headerComponent) return null;

    switch (headerComponent.format) {
      case "TEXT":
        return headerComponent.text ? <h3 key={key}>{headerComponent.text}</h3> : null;

      case "IMAGE":
        return <img style={{ width: "18rem" }} key={key} src={Placeholder} alt="Image Header" />;

      case "VIDEO":
        return <img style={{ width: "18rem" }} key={key} src={Placeholder1} alt="Video Header" />;

      case "DOCUMENT":
        return <img style={{ width: "18rem" }} key={key} src={Placeholder2} alt="Video Header" />;

      default:
        return null;
    }
  }

  // **Render Body Component with Placeholder Replacements**
  function renderBody(bodyComponent, key) {
    if (!bodyComponent?.text) return null;

    let message = bodyComponent.text;

    // Extract example values safely
    const exampleValues = bodyComponent.example?.body_text?.[0] || [];
    const flatExampleValues = Array.isArray(exampleValues) ? exampleValues : [exampleValues];

    // Replace placeholders {{1}}, {{2}}, etc.
    message = message.replace(/\{\{(\d+)\}\}/g, (_, index) => flatExampleValues[index - 1] || "");

    // Convert formatted text into JSX
    const formattedMessage = message.split(/(\*_.*?_\*|\*.*?\*|_.*?_)/g).map((part, i) => {
      if (/^\*_.*?_\*$/.test(part)) return <b key={i}><i>{part.slice(2, -2)}</i></b>;
      if (/^\*.*\*$/.test(part)) return <b key={i}>{part.slice(1, -1)}</b>;
      if (/^_.*_$/.test(part)) return <i key={i}>{part.slice(1, -1)}</i>;
      return part;
    });

    return <p key={key}>{formattedMessage}</p>;
  }

  // **Render Buttons (Quick Reply & URL Buttons)**
  function renderButtons(buttons, key) {
    if (!buttons || buttons.length === 0) return null;

    return (
      <div key={key} className="buttons-container">
        {buttons.map((button, index) => {
          if (button.type === "QUICK_REPLY") {
            return <button key={index} style={{ border: "2px solid #2E8DFB", background: "white", textAlign: "center", width: "100%", color: "#2E8DFB", padding: "0.5rem 0", borderRadius: "10px" }} className="quick-reply">{button.text}</button>;
          }
          if (button.type === "URL" && button.url) {
            return (
              <a key={index} href={button.url} className="url-button" target="_blank" rel="noopener noreferrer">
                {button.text}
              </a>
            );
          }
          return null;
        })}
      </div>
    );
  }

  const ImageComponent = ({ imageUrl }) => {
    return <img src={imageUrl} alt="Dynamic Image" style={{ width: "100%", height: "auto", borderRadius: "10px" }} />;
  };
  const VideoComponent = ({ videoUrl }) => {
    return (
      <video controls width="100%" style={{ borderRadius: "10px" }}>
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  };
  const UniqueDocumentCard = ({ docUrl }) => {
    // Extract filename from URL
    const fileName = docUrl.split("/").pop();

    return (
      <div className="unique-doc-card">
        {/* Document Icon */}
        <div className="unique-doc-icon">📄</div>

        {/* Document Name (Clickable for Download) */}
        <div className="unique-doc-text">
          <a href={docUrl} download className="unique-doc-link">
            {fileName}
          </a>
        </div>
      </div>
    );
  };

  function isValidURL(str) {
    try {
      const url = new URL(str);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch {
      return false;
    }
  }
  function getURLTypeElement(url) {
    try {
      const parsedUrl = new URL(url);
      const pathname = parsedUrl.pathname;
      const search = parsedUrl.search;

      // 👉 Detect catalogue link
      if (pathname === "/food" && search.includes("mobile=") && search.includes("orderid=")) {
        return (
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <FaClipboardList /> Catalogue
          </span>
        );
      }

      const extension = pathname.split('.').pop().toLowerCase();
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
      const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv'];
      const documentExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'];

      if (imageExtensions.includes(extension)) {
        return (
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <FaImage /> Image
          </span>
        );
      } else if (videoExtensions.includes(extension)) {
        return (
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <FaVideo /> Video
          </span>
        );
      } else if (documentExtensions.includes(extension)) {
        return (
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <FaFileAlt /> Document
          </span>
        );
      } else {
        return (
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <FaLink /> Other
          </span>
        );
      }
    } catch {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "5px", color: "gray" }}>
          <FaLink /> Invalid Link
        </span>
      );
    }
  }
  // Template Send Modal code start from here ######################################################################################################################################################



  // Template modal state (you likely already have these)
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(false);

  // WhatsApp numbers (copied pattern from your other screen)
  const [WhatsappNumbers, setWhatsappNumbers] = useState([]);
  const [MultiplePhoneNumber, setMultiplePhoneNumber] = useState(false);
  const [SingleWhatsApp, setSingleWhatsApp] = useState("");

  // Vars for {{1}}, {{2}}… (per-template)
  const [templateVarsById, setTemplateVarsById] = useState({});

  // PER-TEMPLATE media uploads (id → { format: 'IMAGE'|'VIDEO'|'DOCUMENT', mediaId, mediaUrl, isUploading })
  const [templateMedia, setTemplateMedia] = useState({});
  const setTplMedia = (tplId, patch) =>
    setTemplateMedia(prev => ({ ...prev, [tplId]: { ...(prev[tplId] || {}), ...patch } }));

  const getHeaderFormat = (tpl) => {
    const header = tpl?.components?.find(c => c.type === "HEADER");
    return header?.format || null; // "IMAGE" | "VIDEO" | "DOCUMENT" | null
  };
  const getWhatsappNumber = async () => {
    try {
      const raw = JSON.stringify({ userid: userID });
      const res = await fetch(`${baseUrl}/api/Whatsapp/v1.0/getWhatsappNumbers`, {
        method: "POST",
        headers: config.headers,
        body: raw
      });
      const data = await res.json();
      if (data?.responseCode === "00") setWhatsappNumbers(data.response || []);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => { getWhatsappNumber(); }, []);
  useEffect(() => {
    if (!WhatsappNumbers?.length) return;
    if (WhatsappNumbers.length === 1) {
      setMultiplePhoneNumber(false);
      setSingleWhatsApp(WhatsappNumbers[0].phone_no_id);
    } else {
      setMultiplePhoneNumber(true);
      setSingleWhatsApp(WhatsappNumbers[0].phone_no_id);
    }
  }, [WhatsappNumbers]);
  const fetchTemplates = async () => {
    if (!SingleWhatsApp) return;
    try {
      setTemplatesLoading(true);
      const raw = JSON.stringify({ userid: userID, phoneNumberId: SingleWhatsApp });
      const res = await fetch(`${baseUrl}/api/Whatsapp/v1.0/getTemplates`, {
        method: "POST",
        headers: config.headers,
        body: raw
      });
      const data = await res.json();
      if (data?.responseCode === "00") setTemplates(data.response?.data || []);
      else setTemplates([]);
    } catch (e) {
      console.error(e);
    } finally {
      setTemplatesLoading(false);
    }
  };

  useEffect(() => { if (showTemplateModal) fetchTemplates(); }, [SingleWhatsApp, showTemplateModal]);
  const uploadTemplateHeaderMedia = async (tplId, base64String, mediaType /* 'image'|'video'|'pdf' */) => {
    if (!base64String) return;
    setTplMedia(tplId, { isUploading: true });

    const payload = {
      userid: userID,
      mediaData: base64String.split(",")[1] || base64String, // accept raw base64 or data URL
      mediaType: mediaType === 'image' ? 'img' : mediaType === 'video' ? 'video' : 'pdf',
    };

    try {
      const res = await fetch(`${baseUrl}/api/Whatsapp/uploadMedia`, {
        method: "POST",
        headers: { ...config.headers, "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      const json = await res.json();
      if (json?.responseCode === "00") {
        // a lot of your APIs return mediaId (for video/document) or mediaUrl; use both if present
        const mediaId = json?.data?.mediaId || json?.data?.media_id;
        const mediaUrl = json?.data?.mediaUrl || json?.data?.media_url;
        setTplMedia(tplId, { mediaId, mediaUrl });
        toast.success("Media uploaded");
      } else {
        toast.error(json?.responseMessage || "Upload failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("Upload error");
    } finally {
      setTplMedia(tplId, { isUploading: false });
    }
  };

  const handleTemplateMediaFile = (tpl, file) => {
    const format = getHeaderFormat(tpl); // IMAGE | VIDEO | DOCUMENT | null
    if (!file || !format) return;

    // size checks if you want (e.g. 5MB for video)
    const reader = new FileReader();
    reader.onload = () => {
      const mediaType =
        format === "IMAGE" ? "image" :
          format === "VIDEO" ? "video" :
            "pdf"; // treat DOCUMENT as 'pdf' pipe for your upload API
      uploadTemplateHeaderMedia(tpl.id, reader.result, mediaType);
    };
    reader.readAsDataURL(file);
  };
  const executeTemplate = async (tpl) => {
    if (!mobileNumberSelected) {
      toast.error("Select a contact first");
      return;
    }

    // collect {{n}} from BODY and map to inputs we stored
    const body = tpl.components?.find(c => c.type === "BODY");
    const placeholders = (body?.text?.match(/\{\{\d+\}\}/g) || [])
      .map(ph => Number(ph.replace(/[{}]/g, "")))
      .sort((a, b) => a - b)
      .filter((v, i, arr) => arr.indexOf(v) === i);

    const vars = templateVarsById[tpl.id] || [];
    const orderedBodyParams = placeholders.length
      ? placeholders.map((_, idx) => vars[idx] || "")
      : [];

    const headerFormat = getHeaderFormat(tpl); // "IMAGE" | "VIDEO" | "DOCUMENT" | null
    const mediaForTpl = templateMedia[tpl.id] || {};
    const { mediaId, mediaUrl } = mediaForTpl;

    // For media templates, headerParams should carry the media reference.
    // Your sample payload shows headerParams: ["597607503230690"] i.e., a mediaId.
    // We'll prioritize mediaId; if only mediaUrl exists, send that.
    const headerParams = headerFormat ? ([mediaId || mediaUrl].filter(Boolean)) : [];

    const payload = {
      userid: userID,
      secret: "N",
      templateName: tpl.name,
      languageCode: tpl.language || "en",
      messaging_product: "whatsapp",
      contacts: [mobileNumberSelected],
      headerParams,
      bodyParams: orderedBodyParams,
      footerParams: [],
      type: tpl.category || "MARKETING",          // e.g. "MARKETING"
      execute_type: "N",
      format: headerFormat ? headerFormat.toLowerCase() : "text", // "video" | "image" | "document" | "text"
      templateId: tpl.id
    };

    try {
      const res = await fetch(`${baseUrl}/api/Whatsapp/executeTemplate`, {
        method: "POST",
        headers: config.headers,
        body: JSON.stringify(payload),
      });
      const json = await res.json();

      if (json?.responseCode === "00") {
        toast.success(json?.responseMessage || "Template sent");
        setShowTemplateModal(false);
        setTemplateVarsById({});
        // optional: refresh conversation
        fetchChats?.();
      } else {
        toast.error(json?.responseMessage || "Failed to send");
      }
    } catch (e) {
      console.error(e);
      toast.error("Error sending template");
    }
  };

  return (
    <>
      <NoIndex />
      <div className="d-flex justify-content-center">
        {" "}
        <ToastContainer />
      </div>

      <div style={{ display: "flex", height: "100vh" }}>
        <div className="contactsList  "  >
          <div>
            <div className=" row  d-flex justify-content-between border-bottom-chat ">
              <div className=" col-4 m-0 p-0">
                <button
                  className={`btn-chat w-100 p-2 ${activeButton === "1" ? "active-chat" : ""
                    } `}
                  onClick={(e) => {
                    setAllContectShow(false);
                    setChatShow(true);
                    setActiveButton("1");
                    setChats([]);
                    setMobileNumberSelected("");
                    setSelectedContactId("");
                    setContacts([]);
                    setPageIndex(1);
                    setHasMore(true);
                    fetchTabSwitchContact();
                  }}
                >
                  Chats
                </button>
              </div>
              <div className="col-4 m-0 p-0">
                <button
                  className={`btn-chat w-100 p-2 ${activeButton === "2" ? "active-chat" : ""
                    } `}
                  onClick={(e) => {
                    setAllContectShow(true);
                    setChatShow(false);
                    setActiveButton("2");
                    setMobileNumberSelected("");
                    setSelectedContactId("");
                    setContacts([]);
                    setPageIndex(1);
                    setHasMore(true);
                    fetchTabSwitchContact();
                  }}
                >
                  Contacts
                </button>
              </div>
              <div className="col-4 m-0 p-0">
                <button
                  className={`btn-chat w-100 p-2 ${activeButton === "3" ? "active-chat" : ""
                    } `}
                  onClick={(e) => {
                    setSelectedContactId(null);
                    setActiveButton("3");
                  }}
                >
                  + Add
                </button>
              </div>
            </div>
          </div>
          {chatShow && <div
            style={{ overflowY: "auto", scrollbarWidth: "null", height: "100%" }}
            className="loading-list-chat"
            onScroll={(e) => {
              if (!hasMore || isLoadingContacts) return;
              const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
              if (scrollHeight - scrollTop - clientHeight < 100) {
                fetchData();
              }
            }}
          >
            {chatShow && (
              <>
                <div className="d-flex justify-content-between"> <div className="px-4 pt-4 text3 font-bold-400">Recent Chats</div> <button
  style={{color:"#2E8DFB", textDecoration:"underline", cursor:"pointer" ,border:"none", background:"none"
  
  }}

  onClick={() => setShowNewTplModal(true)}
>
  Send New
</button>
</div>

                {contacts
                  .filter(contact => contact.last_conversation !== null)
                  .map(contact => (
                    <div
                      key={contact.id}
                      //  onClick={() => handleSelectContact(contact.id)}
                      onClick={() => handleSelectContact(contact)}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        // padding: "10px 20px",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                        backgroundColor:
                          selectedContactId === contact.id
                            ? "#f0f0f0"
                            : "transparent",
                      }}
                      className="ms-1"
                    >
                      {/* Contact Name */}
                      <div className="d-flex justify-content-between align-items-center" onClick={() => handleSelectContact(contact)}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={wpImage}
                            alt=""
                            style={{
                              width: "40px",
                              height: "40px",
                              marginRight: "10px",
                            }}
                            className="ms-2  p-1"
                          />


                          <div>
                            <div className="d-flex justify-content-between">
                              <div className="my-2 ">{contact.contact_name} {contact?.assigned_user !== "NA" ? <img className="ms-1" title={`${contact.assigned_user.split("|")[0]}}`} src={assignedImg} alt="" /> : ""}</div>


                            </div>
                            <div
                              style={{
                                fontSize: "14px",
                                color: "#666",
                                margin: "5px 0px",
                              }}
                            >
                              {isValidURL(contact.last_conversation) ? getURLTypeElement(contact.last_conversation) : contact.last_conversation.slice(0, 35)}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex">  <div className="d-flex justify-content-end">
                          {contact.unread_count !== "0" && (
                            <span className="unread-badge me-1 ">
                              {contact.unread_count}
                            </span>
                          )}
                        </div>
                          <div className="d-flex justify-content-end align-item-start">
                            <div
                              className="px-2 m-0 text-center"
                              title={`${contact.assigned_user.split("|")[0]}`}
                              style={{
                                display: `${contact.label.title ? "block" : "none"
                                  }`,
                                border: `1px ${contact.label.color} solid`,
                                color: `${contact.label.color}`,
                                borderRight: "none",
                                width: "7rem",
                                borderRadius: "1rem 0rem 0rem 1rem",
                              }}
                            >
                              {contact.label.title}
                            </div>
                          </div></div>



                        {/* <img className="w-10" src={contact.label.icon} alt="" /> */}
                      </div>
                    </div>
                  ))}
                {isLoadingContacts && (
                  <div className="text-center py-3">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>}




          {allContectShow && (
            <div className="loading-list-chat" style={{ overflowY: "auto", scrollbarWidth: "null", height: "100%" }} onScroll={(e) => {
              if (!hasMore || isLoadingContacts) return;
              const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
              if (scrollHeight - scrollTop - clientHeight < 100) {
                fetchData(); // ← same paginated loader you already use
              }
            }}>
              <div className=" px-4 pt-4 text3 font-bold-400">All Contacts</div>
              {contacts.map((contact) => (
                <div
                  key={contact.id}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px 20px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee",
                    backgroundColor:
                      selectedContactId === contact.id
                        ? "#f0f0f0"
                        : "transparent",
                  }}
                  className="ms-2"

                >



                  {/* Contact Name */}
                  <div
                    className="d-flex justify-content-between"
                    style={{ alignItems: "center" }}
                  >
                    <div
                      className="d-flex justify-content-start"
                      onClick={() => {
                        setMobileNumberSelected(contact.contact_number);
                        setSelectedContactId(contact.id);
                        setChats([]);
                      }}
                    >
                      <img
                        src={wpImage}
                        alt=""
                        style={{
                          width: "40px",
                          height: "40px",
                          marginRight: "10px",
                        }}
                        className="  p-1"
                      />
                      <div>
                        <div>{contact.contact_name}</div>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#666",
                            marginTop: "5px",
                          }}
                        >
                          {contact.contact_number}
                          {/* {
                    messages[contact.id]?.[messages[contact.id].length - 1]
                      ?.text
                  } */}
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        onClick={(e) => {
                          deleteContactAPI(contact.contact_number);
                        }}
                        className=" p-2 cursor-pointer text-center  text-white "
                        style={{
                          border: "0px solid #000",
                          borderRadius: "5px",
                        }}
                      >
                        {" "}
                        <img src={trash} alt="Logo" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
              {isLoadingContacts && (
                <div className="text-center py-3">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <div
          className="bg-white"
          style={{ flex: 1, display: "flex", flexDirection: "column" }}
        >
          {loading ? (
            <div
              className=" m-5 p-5 d-flex justify-content-center align-items-center"
              style={{ height: "100%" }}
            >
              <div className="loader "></div>
            </div>
          ) : (
            <>
              {selectedContactId && (
                <div className="p-4 bg-white">
                  <div
                    style={{ position: "sticky", top: 0 }}
                    className=" d-flex justify-content-between font2 text-white text-start border-radius-20 p-2 px-3 font3 font-bold-400 bg-green-filter align-items-center"
                  >
                    {/* chat person details */}
                    <div className="">
                      {
                        contacts.find(
                          (contact) => contact.id === selectedContactId
                        )?.contact_name
                      }

                      {/* {
                      contacts.find(
                        (contact) => contact.id === selectedContactId
                      ).contact_number
                    } */}
                    </div>



                    {/* dropdowns */}


                    <div>

                      <div className="d-flex">

                        <select

                          className="form-select me-2"

                          aria-label="Default select example"

                          value={SelectedPeople ? SelectedPeople :
                            contacts.find(
                              (contact) => contact.id === selectedContactId
                            )?.assigned_user}
                          onChange={(e) => setSelectedPeople(e.target.value)}
                          onClick={() => setSelectedContact2(selectedContactId)}
                        >
                          <option>Assign Chat</option>
                          {People.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.user_name}
                            </option>
                          ))}
                        </select>
                        <select
                          className="form-select me-2"
                          aria-label="Default select example"
                          value={selectedLabel ? selectedLabel :
                            contacts?.find(
                              (contact) => contact.id === selectedContactId
                            )?.label.title
                          }
                          onChange={handleSelectChange}
                          onClick={() => setSelectedContact1(selectedContactId)}
                        >
                          <option>Add Label</option>
                          {Labels.map((item, index) => (
                            <option key={index} value={item.title}>
                              {item.title}
                            </option>
                          ))}
                        </select>
                        <button
                          //  onClick={() => setShowModal(true)}
                          onClick={() => setSelectedContact(selectedContactId)}
                          className=" cursor-pointer text-centersss bg-white text-white me-1"
                          style={{
                            border: "0px solid #000",
                            borderRadius: "0.5rem",
                          }}
                        >
                          <img
                            style={{ width: "2rem" }}
                            src={Edit}
                            alt="Logo"
                          />

                          {/* Edit */}
                        </button>
                      </div>

                      <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Edit Contact</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <form onSubmit={handleEditContactSubmit}>
                            <div className="form-group d-flex my-2">
                              <label
                                style={{ width: "5rem" }}
                                htmlFor="contactName"
                              >
                                Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="contactName"
                                name="contactName"
                                value={contactInfo.contactName}
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                            <div className="form-group d-flex my-2">
                              <label
                                style={{ width: "5rem" }}
                                htmlFor="contactNumber"
                              >
                                Number
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="contactNumber"
                                name="contactNumber"
                                value={contactInfo.contactNumber}
                                onChange={handleInputChange}
                                required
                              />
                            </div>
                            <div className="form-group d-flex my-2">
                              <label
                                style={{ width: "5rem" }}
                                htmlFor="contactEmail"
                              >
                                Email
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                id="contactEmail"
                                name="contactEmail"
                                value={contactInfo.contactEmail}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="form-group d-flex my-2">
                              <label style={{ width: "5rem" }} htmlFor="gender">
                                Gender
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="gender"
                                name="gender"
                                value={contactInfo.gender}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="form-group d-flex my-2">
                              <label style={{ width: "5rem" }} htmlFor="tags">
                                Tags
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="tags"
                                name="tags"
                                value={contactInfo.tags}
                                onChange={handleInputChange}
                              />
                            </div>
                            <div className="d-flex my-2 justify-content-center mt-3">
                              <button
                                type="submit"
                                className="btn bg-green-filter text-center text-white  "
                              >
                                Submit
                              </button>
                            </div>
                          </form>
                        </Modal.Body>
                      </Modal>
                    </div>
                  </div>
                </div>
              )}
              {/* // Chat Window of the Chat Section */}
              <div
                className="p-4 bg-white contactsList_chat"
                style={{
                  flex: 1,
                  overflowY: "auto",
                  padding: "0px",
                  backgroundImage: `url(${Chat_BG})`,
                  backgroundRepeat: "repeat",
                  backgroundPosition: "center",

                  backgroundSize: "30%",
                }}
                ref={chatContainerRef}
                onScroll={(e) => {
                  const { scrollTop } = e.currentTarget;
                  if (scrollTop < 100 && chatHasMore && !isLoadingChats) {
                    fetchChats();
                  }
                }}
              >
                <>
                  {isLoadingChats && (
                    <div className="text-center py-2">
                      <div className="spinner-border text-secondary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                  {/* <div className="bg-dark p-5 m-5 text-white"> hiii{chats.length}</div> */}
                  {selectedContactId ? (
                    chats.length === 0 ? (
                      <div className="text-3-2 d-flex justify-content-center align-items-center ">
                        No Chat Found !
                      </div>
                    ) : (
                      chats?.map((chat) => (

                        <div
                          key={chat.message_id}
                          style={{
                            textAlign: chat.sender === "1" ? "right" : "left",
                            margin: "10px 0",
                          }}
                        >
                          <div
                            style={{ width: "20rem" }}
                            className={`
  ${chat.message_type === "template" ? "message-container-template" : "message-container"}
  ${chat.sender === "1"
                                ? chat.message_type === "button" && chat.message_type !== "order_review"
                                  ? "sent1 p-0 pt-3"
                                  : chat.message_type === "template" ? "sent" : "sent"
                                : chat.message_type === "template"
                                  ? "sent-template"
                                  : "received"
                              }
`}
                          >
                            <p
                              className={` message-text  ${chat.sender === "1"
                                ? "text-start "
                                : "text-start"
                                }`}
                            >
                              <div className="d-flex"></div>
                              {chat.reply_to ? (
                                <div
                                  className="d-flex text-dark rounded mb-2"
                                  style={{
                                    border: "1px solid #ccc",
                                    borderLeft: "3px solid #01C37D ",
                                    backgroundColor: "#ffff",
                                  }}
                                >
                                  <div className="mx-3 text-break">
                                    {chat.reply_to}
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                              {chat.message_type === "order_review" ? <div><p className="text-muted card-footer small">Order ID :   {
                                JSON.parse(JSON.stringify(chat.message)).orderId
                              }</p>
                                <div style={{ borderTop: "1px dashed #ccc", margin: "10px 0" }}></div>
                                <div
                                  className="d-flex text-dark rounded mb-1"
                                >
                                  <img
                                    style={{
                                      width: "4rem",
                                    }}
                                    src={food}
                                    alt=""
                                  />
                                  <div>  <div className="d-flex align-items-center p-1 text-mute small"><b> {chat.message_type === "order_review" ?
                                    JSON.parse(JSON.stringify(chat.message)).itemName.slice(0, 25) :
                                    chat.message
                                  }</b>
                                  </div>
                                  </div>
                                </div>
                                <div style={{ borderTop: "1px dashed #ccc", margin: "10px 0" }}></div>
                                <div className="d-flex align-items-center justify-content-between p-1 text-mute small"><div><b>Total :</b> </div>
                                  <div>{chat.message_type === "order_review" ?
                                    JSON.parse(JSON.stringify(chat.message)).total :
                                    chat.message
                                  }</div>
                                </div>
                              </div> : <></>
                              }
                              {chat.message_type === "catalogue" ? (
                                <div
                                  className="d-flex bg-white text-dark rounded mb-1"
                                  style={{ border: "1px solid #ccc" }}
                                >
                                  <img
                                    style={{
                                      width: "7rem",
                                    }}
                                    src={food}
                                    alt=""
                                  />
                                  <div className="d-flex align-items-center p-1 text-mute">
                                    Your Catalogue on WhatsApp
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                              {chat.message_type === "catelogue_order" ? (
                                <div
                                  className="d-flex bg-white text-dark rounded mb-1"
                                  style={{ border: "1px solid #ccc" }}
                                >
                                  <img
                                    style={{
                                      width: "7rem",
                                    }}
                                    src={Cart}
                                    alt=""
                                  />
                                  <div className="d-flex align-items-center justify-content-end p-1 text-mute">
                                    {chat.message.slice(0, 8)}
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                              <div
                                className={` ${chat.message_type === "button"
                                  ? "text-center"
                                  : ""
                                  }`}
                              >
                                {chat.message_type === "catelogue_order" ? (
                                  <p className="fw-medium">
                                    {chat.message.slice(9)}
                                  </p>
                                ) : (
                                  <p>
                                    {chat.message_type === "order_review" ?
                                      JSON.parse(JSON.stringify(chat.message)).message : chat.message_type === "template" ?
                                        <>{formatWhatsAppMessage(chat.message)}</> : chat.message_type === "image" ? <ImageComponent imageUrl={chat.message} /> : chat.message_type === "video" ? <VideoComponent videoUrl={chat.message} /> : chat.message_type === "document" ? <UniqueDocumentCard docUrl={chat.message} /> : chat.message
                                    }
                                  </p>
                                )}
                              </div>
                            </p>
                            <p
                              className={` p-0 m-0  message-timestamp ${chat.sender === "1" ? "text-end" : "text-end"
                                }`}
                            >
                              {chat.message_type === "catelogue_order" || chat.message_type === "order_review" ? (
                                <hr />
                              ) : (
                                ""
                              )}
                              {chat.message_type === "catelogue_order" ? (
                                <div
                                  className="bg-white d-flex justify-content-center my-2 py-2 cursor-pointer rounded-2 "
                                  style={{
                                    color: " #01C37D",
                                    border: "2px solidrgb(201, 251, 162)",
                                  }}
                                // onClick={() => navigate("/Orders/Catalogue")}
                                >
                                  View Sent Cart
                                </div>
                              ) : (
                                <></>
                              )}
                              {chat.message_type === "order_review" ? (
                                <div
                                  className="bg-white d-flex justify-content-center my-2 py-2 cursor-pointer rounded-2 "
                                  style={{
                                    color: " #01C37D",
                                    border: "2px solidrgb(201, 251, 162)",
                                  }}
                                // onClick={() => navigate("/Orders/Catalogue")}
                                >
                                  Review and pay
                                </div>
                              ) : (
                                <>

                                </>
                              )}
                              {chat.message_type === "catalogue" ? <hr /> : ""}
                              {chat.message_type === "catalogue" ? (
                                <div
                                  className="bg-white d-flex justify-content-center my-2 py-2 cursor-pointer rounded-2 "
                                  style={{
                                    color: " #01C37D",
                                    border: "2px solidrgb(201, 251, 162)",
                                  }}
                                  onClick={() => navigate("/Orders/Catalogue")}
                                >
                                  View Catalogue
                                </div>
                              ) : (
                                <>

                                </>
                              )}
                              {chat.message_type === "button" || chat.message_type === "video" || chat.message_type === "image" || chat.message_type === "document" || chat.message_type === "template" ? (
                                <p></p>
                              ) : (
                                <p class="card-text">
                                  <small class="text-body-secondary">
                                    {chat.datetime}
                                  </small>
                                </p>
                              )}
                            </p>
                          </div>
                          <div ref={messagesEndRef}></div>
                        </div>
                      ))
                    )
                  ) : (
                    <p>
                      <ContectBook userID={userID} fetchData={fetchData} />
                    </p>
                  )}
                </>
              </div>
            </>
          )}
          {selectedContactId && (
            <>
              <div
                className="px-4 d-flex align-items-center"
                style={{ borderTop: "1px solid #ccc", padding: "10px", position: "relative" }}
              >




                {/* Attachment Dropup (Dropdown opens upwards now) */}
                {/* Media Modal */}
                <Button
                  variant="light"
                  className="px-3 py-2 me-2   d-flex align-items-center"
                  onClick={() => openModal()}
                  title="Uploded Media"
                >
                  <Folder color="#0d6efd" />
                </Button>
                <button
                  title="template"
                  className="btn btn-light px-3 py-2 me-2"
                  onClick={() => setShowTemplateModal(true)}
                >
                  <LayoutTemplate color="#0d6efd" />
                </button>




                <Modal show={showMediaModal} onHide={handleCloseModal} centered size="lg">
                  <Modal.Header closeButton className="border-0">
                    <Modal.Title className="fw-bold text-dark">
                      <div className="d-flex justify-content-between">
                        <div>
                          <div>
                            📁 Available Media
                          </div>
                          {/* <div className="text-muted fs-6"> (Select an item to send) </div> */}
                        </div>
                        <div>
                          <Dropdown drop="up" className="ms-3">
                            <Dropdown.Toggle variant="light" className="d-flex align-items-center px-3 py-2 shadow-sm rounded">
                              <img src={attach} alt="Attach" width="20" height="20" className="me-2" />
                              <span className="fw-bold">
                                {!mediaUploadLoading ?
                                  <> Upload New Item</> :
                                  <>
                                    Uploading...
                                  </>
                                }





                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="shadow-lg border-0 p-2 rounded-3">
                              <Dropdown.Item
                                className="d-flex align-items-center px-3 py-2"
                                onClick={() => { setMediaType("img"); imageInputRefupload.current.click(); }}
                              >
                                <img src={attachimage} alt="Attach" width="20" height="20" className="me-2" />
                                <span className="fw-semibold">Image</span>
                              </Dropdown.Item>
                              <Dropdown.Item
                                className="d-flex align-items-center px-3 py-2"
                                onClick={() => { setMediaType("video"); videoInputRefupload.current.click(); }}
                              >
                                <img src={attachvideo} alt="Attach" width="20" height="20" className="me-2" />
                                <span className="fw-semibold">Video</span>
                                <small className="text-muted ms-1"> {" "}Max: 5MB</small>
                              </Dropdown.Item>
                              <Dropdown.Item
                                className="d-flex align-items-center px-3 py-2"
                                onClick={() => { setMediaType("pdf"); documentInputRefupload.current.click(); }}
                              >
                                <img src={attachdoc} alt="Attach" width="20" height="20" className="me-2" />
                                <span className="fw-semibold">Document</span>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                          {/* Hidden File Inputs */}
                          <input
                            type="file"
                            accept="image/*"
                            ref={imageInputRefupload}
                            className="d-none"
                            onChange={handleFileSelectUpload}
                          />
                          <input
                            type="file"
                            accept="video/*"
                            ref={videoInputRefupload}
                            className="d-none"
                            onChange={handleFileSelectUpload}
                          />
                          <input
                            type="file"
                            accept=".pdf,.doc,.docx,.xls,.xlsx"
                            ref={documentInputRefupload}
                            className="d-none"
                            onChange={handleFileSelectUpload}
                          />
                        </div>
                      </div>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="bg-light">
                    {loading ? (
                      <p className="text-center fw-bold text-muted">Fetching media...</p>
                    ) : mediaList.length > 0 ? (
                      <>
                        <Row className="g-3">
                          {currentMedia.map((media) => (
                            <Col key={media.id} md={4}>
                              <Card
                                className={`shadow-sm w-100 rounded overflow-hidden border-0 position-relative ${selectedMedia === media.media_url ? "bg-success text-white border-3 shadow-lg p-1" : "hover-shadow p-1"
                                  }`}
                                style={{ transition: "0.3s ease-in-out", cursor: "pointer" }}
                                onClick={() => {
                                  setSelectedMedia(media.media_url);
                                  setSelectedMediaId(media.id);
                                }}
                              >
                                {media.media_url.endsWith(".mp4") ? (
                                  <video
                                    src={media.media_url}
                                    className="card-img-top"
                                    controls
                                    style={{ height: "180px", objectFit: "cover" }}
                                  />
                                ) : (
                                  <embed
                                    src={media.media_url}
                                    className="card-img-top"
                                    style={{ height: "180px", width: "100%", objectFit: "contain", background: "#f8f9fa", border: "none" }}
                                  />
                                )}
                                <Card.Body className="text-center py-2">
                                  <div className="mt-2 footer-text">
                                    <span
                                      className={`text-decoration-none fw-semibold ${selectedMedia === media.media_url ? "text-white" : "text-dark"
                                        }`}
                                    >
                                      {media.media_id || "View Media"}
                                    </span>
                                  </div>
                                </Card.Body>
                              </Card>
                            </Col>
                          ))}
                        </Row>
                        {/* Pagination Controls */}
                        <div className="d-flex justify-content-center align-items-center mt-3">
                          <button
                            className="btn btn-primary"
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                          >
                            Previous
                          </button>
                          <span className="fw-bold mx-3">Page {currentPage}</span>
                          <button
                            className="btn btn-primary"
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                            disabled={indexOfLastItem >= mediaList.length}
                          >
                            Next
                          </button>
                        </div>
                      </>
                    ) : (
                      <p className="text-center fw-bold text-muted">No media available</p>
                    )}
                  </Modal.Body>
                  {/* Show the Send Button Only When a Media is Selected */}
                  <Modal.Footer className="border-0">
                    {selectedMedia && (
                      <Button
                        variant="success"
                        className="px-4 rounded-pill"
                        onClick={sendMediaToUser}
                        disabled={sending}
                      >
                        {sending ? "Sending..." : "Send to User"}
                      </Button>
                    )}
                    <Button variant="secondary" className="px-4 rounded-pill" onClick={handleCloseModal}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>
                <Dropdown drop="up" className="me-2">
                  <Dropdown.Toggle variant="light" className="d-flex align-items-center px-3 py-2 shadow-sm rounded">
                    <Paperclip className="text-blue-600" size={24} color="#0d6efd" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="shadow-lg border-0 p-2 rounded-3">
                    <Dropdown.Item
                      className="d-flex align-items-center px-3 py-2"
                      onClick={() => { setMediaType("img"); imageInputRef.current.click(); }}
                    >
                      <i className="bi bi-image-fill text-primary me-2"></i>
                      <span className="fw-semibold"> <img src={attachimage} alt="Attach" width="20" height="20" className="me-2" />Image</span>
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="d-flex align-items-center px-3 py-2"
                      onClick={() => { setMediaType("video"); videoInputRef.current.click(); }}
                    >
                      <i className="bi bi-camera-reels-fill text-danger me-2"></i>
                      <span className="fw-semibold"><img src={attachvideo} alt="Attach" width="20" height="20" className="me-2" />Video</span>
                      <small className="text-muted ms-1"> {" "}Max: 16 MB</small>
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="d-flex align-items-center px-3 py-2"
                      onClick={() => { setMediaType("pdf"); documentInputRef.current.click(); }}
                    >
                      <i className="bi bi-file-earmark-text-fill text-success me-2"></i>
                      <span className="fw-semibold"><img src={attachdoc} alt="Attach" width="20" height="20" className="me-2" />Document</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                {/* Hidden File Inputs */}
                <input
                  type="file"
                  accept="image/*"
                  ref={imageInputRef}
                  className="d-none"
                  onChange={handleFileSelect}
                />
                <input
                  type="file"
                  accept="video/*"
                  ref={videoInputRef}
                  className="d-none"
                  onChange={handleFileSelect}
                />
                <input
                  type="file"
                  accept=".pdf,.doc,.docx,.xls,.xlsx"
                  ref={documentInputRef}
                  className="d-none"
                  onChange={handleFileSelect}
                />
                {mediaLoading ? (
                  <div className="mt-2 d-flex w-100 justify-content-center flex-column align-items-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Please wait, {mediaType} is sending...</p>
                  </div>
                ) : previewUrl ? (
                  <div className="mt-2 w-100 d-flex justify-content-center position-relative">
                    {/* Cancel Button */}
                    <button
                      onClick={removeFile}
                      className="btn position-absolute"
                      style={{
                        top: "-10px",
                        right: "10%",
                        padding: "5px 10px",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                    >
                      ❌
                    </button>
                    {/* Media Preview Based on mediaType */}
                    {mediaType === "video" ? (
                      <video width="50%" controls>
                        <source src={previewUrl} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    ) : mediaType === "img" ? (
                      <img
                        src={previewUrl}
                        alt="Selected"
                        style={{ maxWidth: "50%", maxHeight: "300px", objectFit: "cover" }}
                      />
                    ) : mediaType === "pdf" ? (
                      <iframe
                        src={previewUrl}
                        title="Document Preview"
                        style={{ width: "60%", height: "300px", border: "1px solid #ccc" }}
                      />
                    ) : null}
                  </div>
                ) : (
                  <form style={{ width: "100%", marginRight: "2px" }} onSubmit={handleSubmit}>
                    <input
                      type="text"
                      className="p-2 my-2 w-100 form-control"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Type a message"
                      disabled={!!selectedFile} // Disable input if a file is selected
                    />
                  </form>
                )}

                {/* Send Button */}
                <button
                  type="submit"
                  className="bg-white border-0"
                  onClick={handleSubmit}
                  disabled={!message && !selectedFile} // Disable button if no text or file
                >
                  <img src={sendImage} height={40} alt="Send" />
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      {/* // Template Send Modal code start from here  */}
      <Modal show={showTemplateModal} onHide={() => setShowTemplateModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="w-100 d-flex justify-content-between align-items-center">
            <span>WhatsApp Templates</span>
            <div className="d-flex align-items-center">
              {/* <label className="me-2 mb-0">WhatsApp Number</label> */}
              <select
                className="form-select"
                style={{ minWidth: 260 }}
                value={SingleWhatsApp}
                onChange={(e) => setSingleWhatsApp(e.target.value)}
                disabled={!MultiplePhoneNumber}
              >
                <option value="">Select Number</option>
                {WhatsappNumbers.map((n, i) => (
                  <option key={i} value={n.phone_no_id}>
                    {n.phone_no_id} - ({n.phone_no})
                  </option>
                ))}
              </select>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {templatesLoading ? (
            <div className="text-center py-4">Loading templates...</div>
          ) : templates.length === 0 ? (
            <div className="text-center py-4">No templates found.</div>
          ) : (
            <div className="row">
              {templates.map((tpl) => {
                const body = tpl.components?.find(c => c.type === "BODY");
                const headerFormat = getHeaderFormat(tpl); // IMAGE|VIDEO|DOCUMENT|null
                const bodyText = body?.text || "";

                // placeholders in BODY
                const ph = (bodyText.match(/\{\{\d+\}\}/g) || [])
                  .map(s => Number(s.replace(/[{}]/g, "")))
                  .sort((a, b) => a - b)
                  .filter((v, i, a) => a.indexOf(v) === i);

                const vars = templateVarsById[tpl.id] || [];
                const m = templateMedia[tpl.id] || {};

                return (
                  <div key={tpl.id} className="col-md-6 mb-3">
                    <div className="card p-3 shadow-sm h-100 w-100 d-flex">
                      <div className="d-flex justify-content-between align-items-center">
                        <h6 className="mb-1">{tpl.name}</h6>
                        <span className="badge bg-light text-dark">{tpl.category}</span>
                      </div>
                      <div className="small text-muted mb-2">
                        Language: <b>{tpl.language}</b> | Status: <b>{tpl.status}</b>
                      </div>

                      {/* Body preview */}
                      <div className="small" style={{ maxHeight: 100, overflow: "auto" }}>
                        {bodyText}
                      </div>

                      {/* Header media upload if needed */}
                      {headerFormat && (
                        <div className="mt-2">
                          <div className="fw-semibold small mb-1">
                            Header Media ({headerFormat})
                          </div>
                          <input
                            type="file"
                            accept={
                              headerFormat === "IMAGE" ? "image/*" :
                                headerFormat === "VIDEO" ? "video/*" :
                                  ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                            }
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (!file) return;
                              handleTemplateMediaFile(tpl, file);
                            }}
                            disabled={m.isUploading}
                          />
                          {m.isUploading && <div className="small mt-1">Uploading...</div>}
                          {(m.mediaId || m.mediaUrl) && (
                            <div className="small mt-1 text-success">
                              Media attached ✓
                            </div>
                          )}
                        </div>
                      )}

                      {/* Vars for {{n}} */}
                      {ph.length > 0 && (
                        <div className="mt-2">
                          <div className="fw-semibold small mb-1">Template Variables</div>
                          {ph.map((n, idx) => (
                            <input
                              key={n}
                              className="form-control form-control-sm mb-2"
                              placeholder={`Value for {{${n}}}`}
                              value={vars[idx] || ""}
                              onChange={(e) => {
                                const next = [...vars];
                                next[idx] = e.target.value;
                                setTemplateVarsById(prev => ({ ...prev, [tpl.id]: next }));
                              }}
                            />
                          ))}
                        </div>
                      )}

                      <div className="mt-auto d-flex justify-content-end">
                        <button
                          className="btn btn-success btn-sm"
                          onClick={() => executeTemplate(tpl)}
                          disabled={m.isUploading}
                        >
                          Send
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </Modal.Body>
      </Modal>
{/* Send template modal  */}
<NewNumberTemplateModal
  show={showNewTplModal}
  onClose={() => setShowNewTplModal(false)}
  userID={userID}
  baseUrl={baseUrl}
  headers={config.headers}
  onSent={() => {
    // optional: toast or refresh chat lists, etc.
  }}
/>

    </>
  );
};
export default Chats;